import { BUFFER_LENGTH, PLOT_SIZE } from '@coderaw/runtime'

const WOOD = 4
const STONE = 5
const ASH = 6
const NIGHT = 0

const index = (x: number, y: number): number => y * PLOT_SIZE + x

/**
 * Scaffolding over a broken plot: a frame plus diagonal planks every 8 px.
 * Pure: returns a new buffer, the last good frame is untouched.
 */
export const withScaffolding = (buffer: Uint8Array): Uint8Array => {
  const out = new Uint8Array(buffer)
  for (let y = 0; y < PLOT_SIZE; y++) {
    for (let x = 0; x < PLOT_SIZE; x++) {
      const onFrame = x === 0 || y === 0 || x === PLOT_SIZE - 1 || y === PLOT_SIZE - 1
      const onPlank = (x + y) % 8 === 0
      if (onFrame || onPlank) out[index(x, y)] = WOOD
    }
  }
  return out
}

const SMOKE_PUFFS = 7

/** Smoke rising over an overheated plot. `frame` drifts the puffs upward. */
export const withSmoke = (buffer: Uint8Array, frame: number): Uint8Array => {
  const out = new Uint8Array(buffer)
  for (let i = 0; i < BUFFER_LENGTH; i++) {
    if ((i + (i >> 6)) % 2 === 0) out[i] = NIGHT // dim with a checker so the frame stays readable
  }
  for (let p = 0; p < SMOKE_PUFFS; p++) {
    const cx = 8 + p * 8
    const cy = PLOT_SIZE - ((frame * 2 + p * 11) % (PLOT_SIZE + 8))
    const radius = 2 + (p % 3)
    for (let dy = -radius; dy <= radius; dy++) {
      for (let dx = -radius; dx <= radius; dx++) {
        if (dx * dx + dy * dy > radius * radius) continue
        const x = cx + dx
        const y = cy + dy
        if (x < 0 || y < 0 || x >= PLOT_SIZE || y >= PLOT_SIZE) continue
        out[index(x, y)] = (dx + dy) % 2 === 0 ? ASH : STONE
      }
    }
  }
  return out
}

/** A flat plot of one colour, for the moment before any code exists. */
export const emptyPlot = (color = NIGHT): Uint8Array => new Uint8Array(BUFFER_LENGTH).fill(color)
